export const accordionContainerSx = { marginTop: '48px' };
